import App from './App.svelte';
import './main.css';

const app = new App({
  target: document.querySelector('.container'),
});

export default app;
